import { render, staticRenderFns } from "./DebtCharts.vue?vue&type=template&id=1fb554b9"
import script from "./DebtCharts.vue?vue&type=script&lang=js"
export * from "./DebtCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports